import React, { useEffect, useState } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
// import PagedResultSet from 'src/models/common/PagedResultSet';
// import Expense from 'src/models/AP/Expense';
import useFetch from 'use-http';
import LedgerAccount from 'src/models/AP/GeneralLedgerAccount';
import { ODataOptions, ODataFilter, ODataFilterOperators } from 'src/util/ODataBuilder';
import { ITableConfig } from 'src/components/common/table';
// import VendorDefaultAccount from 'src/models/AP/VendorDefaultAccount';
import Account from 'src/models/Account';
import _ from 'lodash';
import PagedResultSet from 'src/models/common/PagedResultSet';

interface IFindAvailableAccountsDialogProps {
    dialogName: string;
    cancelClicked?: () => void;
    handleOKClicked?: (ledgerAccount: LedgerAccount) => void;
    handleSelectedAccount?: (account: Account) => void;
    hideDialog: () => void;
}

const FindAvailableAccountsDialog = (props: IFindAvailableAccountsDialogProps) => {
    const { register, errors, getValues } = useForm();
    const [accounts, setAccounts] = useState<PagedResultSet<LedgerAccount>>(undefined);
    const [selectedAccountIndex, setSelectedAccountIndex] = useState<number>(-1);
    const [accountList, setAccountList] = useState<Account[]>(undefined); // The whole personnel list
    const [ledgerSearchOptions, setLedgerSearchOptions] = useState<ODataOptions>(undefined);
    const [ledgerSearchTerm, setLedgerSearchTerm] = useState<string>(undefined);
    const [fetchNextPage, setFetchNextPage] = useState<boolean>(true);
    const { get, response } = useFetch();

    const getLedgerAccounts = async (filter: string) => {
        if (!!filter) {
            ledgerSearchOptions?.addFilter(new ODataFilter('ACCT_NO', ODataFilterOperators.Contains, filter));
            ledgerSearchOptions?.addFilter(new ODataFilter('ACCT_DSCR', ODataFilterOperators.Contains, filter));
        }
        let result = await get(`/v1.0/Accounting/ledger/accounts${ledgerSearchOptions?.toString()}`);
    
        if (response.ok) {
            if (ledgerSearchOptions.getPageNumber() > 1) {
                let tempResult = _.cloneDeep(accounts);
                tempResult.items = [...tempResult.items].concat([...result.items]);
                setAccounts(tempResult);
            } else {
                setAccounts(result);
            }
            setFetchNextPage(result.pageNumber * result.pageSize < result.totalRecords);
        } else {
            console.log('Unable to get General Ledger Accounts Data!!!');
        }
        ledgerSearchOptions.clearFilters();
    };

    const search = _.debounce(() => {
        let searchName = getValues()?.search;
        setLedgerSearchTerm(searchName);
    }, 800);

    const initializeLedgerSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'ACCT_NO',
            pageNumber: 1,
            columns: []
        };
        setLedgerSearchOptions(ODataOptions.from(tableConfig));
    };

    const resetLedgerSearchOptions = () => {
        accounts.items = [];
        setAccountList(accounts.items);
        setFetchNextPage(true);
        let newLedgerSearchOptions = _.cloneDeep(ledgerSearchOptions);
        newLedgerSearchOptions.clearFilters();
        newLedgerSearchOptions.addPaging(1, 50);
        setLedgerSearchOptions(newLedgerSearchOptions);
    };

    const getScrollStatus = (divElement: HTMLDivElement) => {
        if (divElement) {
            const scrollTop = divElement.scrollTop % 1 > .9 ? divElement.scrollTop : Math.round(divElement.scrollTop);
            const scrollHeight = divElement.scrollHeight;
            const clientHeight = divElement.clientHeight;

            // Check if reached the end of the list
            if (scrollTop + clientHeight >= scrollHeight) {
                incrementLedgerAccounts();
                console.log('end of scroll YES');
            } else {
                console.log('end of scroll NO');
            }
        }
    };

    const incrementLedgerAccounts = () => {
        if (!!fetchNextPage) {
            let newSearchOptions = _.cloneDeep(ledgerSearchOptions);
            newSearchOptions.incrementPageNumber();
            setLedgerSearchOptions(newSearchOptions);
        }
    };
    
    useEffect(() => {
        onCreate();
    }, []);

    useEffect(() => {
        if (!!ledgerSearchTerm || ledgerSearchTerm === '') {
            resetLedgerSearchOptions();
        }
    }, [ledgerSearchTerm]);

    useEffect(() => {
        if (!!ledgerSearchOptions) {            
            getLedgerAccounts(ledgerSearchTerm);
        }
    }, [ledgerSearchOptions]);

    const onCreate = () => {
        initializeLedgerSearchSettings();
        console.log('FindVendorDialog onCreate()');
    };

    useEffect(() => {
        if (!!accounts && accounts?.items?.length > 0) {
            setAccountList(accounts.items);
        }
    }, [accounts]);

    const OKClicked = () => {
        props.handleOKClicked(accounts[selectedAccountIndex - 1]);
        props.hideDialog();
    };

    const accountDoubleClicked = (index: number) => {
        props.handleOKClicked(accounts?.items[index]);
    };

    const setSelectedVoucherAccount = (index: number) => {
        console.log('Selected account index:' + index);
        setSelectedAccountIndex(index);
    };

    return (
        <Dialog title="Available Accounts" dialogName={props.dialogName} isExitButtonInvisible={false} bodyStyle={{ width: '40%' }}>
                <RHFInputBox 
                    labelOnLeft={true} 
                    labelStyle={{ marginTop: '1.5rem' }} 
                    label="Find" 
                    name={'search'} 
                    register={register}
                    errors={errors}
                    style={{ width: '50%', marginTop: '1rem' }}
                    bodyStyle={{ marginLeft: '25%' }}
                    onChange={() => search()}
                />
                    <form>
                        <table style={{ width: '100%' }}>
                            <thead style={{ textAlign: 'left' }}>
                                <tr>
                                    <th>Account</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                            <div onScroll={(event) => getScrollStatus(event.currentTarget)} style={{marginTop: '3rem', overflowY: 'auto', maxHeight: '500px'}}>
                            {accountList?.map((account: LedgerAccount, index: number) => {
                                return (
                                        <tr
                                            key={ account.id + '' + account.index }
                                            className="table-item-hover" 
                                            style={ account?.index === selectedAccountIndex ? { background: 'yellow', textAlign: 'left' } : {textAlign: 'left'}} 
                                            onClick={() => setSelectedVoucherAccount(index + 1)}
                                        >
                                            <td style={{ width: '20%' }}>
                                                <label>{account.accountNumber}</label>
                                                {/* <RHFInputBox
                                                    name={`accounts[${index}].accountNumber`}
                                                    type="text"
                                                    defaultVal={account.accountNumber + ''}
                                                    register={register}
                                                    errors={errors}
                                                    style={{ width: '100%' }}
                                                    bodyStyle={{ width: '100%' }}
                                                    onClick={ () => setSelectedAccount(index)}
                                                    onDoubleClick={ () => accountDoubleClicked(index)}
                                                /> */}
                                            </td>
                                            <td style={{ width: '80%' }}>
                                                <label
                                                    onClick={ () => setSelectedAccountIndex(index)}
                                                    onDoubleClick={ () => accountDoubleClicked(index)}
                                                >{account.description}
                                                </label>
                                                {/* <RHFInputBox
                                                    name={`accounts[${index}].description`}
                                                    type="text"
                                                    defaultVal={account.description}
                                                    register={register}
                                                    errors={errors}
                                                    style={{ width: '100%' }}
                                                    bodyStyle={{ width: '100%' }}
                                                    onClick={ () => setSelectedAccount(index)}
                                                    onDoubleClick={ () => accountDoubleClicked(index)}
                                            /> */}
                                            </td>
                                        </tr>
                                    );
                                })}
                                </div>
                            </tbody>
                        </table>
                    </form>
                <div className="form-row" style={{marginTop: '2rem', marginLeft: '33%', textAlign: 'center'}}>
                    <Button
                        className="blue-hover-button"
                        style={{ width: '20%', marginRight: '1rem' }}
                        text={'Find'}
                        onClick={() => OKClicked()}
                    />
                    <Button
                        className="blue-hover-button"
                        style={{ width: '20%', marginRight: '1rem' }}
                        text={'OK'}
                        onClick={() => OKClicked()}
                    />
                    <Button
                        className="blue-hover-button"
                        style={{ width: '20%', marginRight: '1rem' }}
                        text={'Cancel'}
                        onClick={() => props.cancelClicked()}
                    />
                </div>
        </Dialog>
    );
};

export default FindAvailableAccountsDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/FindAvailableAccountsDialog.tsx